import React from 'react'
import TopicTable from './TopicTable'
import { Input, Button } from 'semantic-ui-react'
import { Loader } from 'shared/components/Loader'
import { TooltipLabel } from 'components/TooltipLabel'

const TopicContent = ({
  topicDataLoading,
  handleSwitchTab,
  tabName,
  handleToggleActive,
  handleSearch,
  pagination,
  searchText,
  filteredDataSource,
  handleEditAction,
  handlePageChange,
  allowAdminOrAbove,
  handleDelete,
  updateTopicLoading,
  createTopicLoading,
}) => {
  return (
    <React.Fragment>
      <div className="flex justify-between items-center py-4">
        <h3 className="m-0">
          Topics
          <TooltipLabel
            className="tooltip"
            descriptionTitle="Topics"
            descriptionContent={
              'Topics can be associated with responses automatically through AI or added manually. Toggle visibility to control which topics appear on responses. Only visible topics will be displayed with the response.'
            }
          />
        </h3>
        <div className="flex">
          <Input
            icon="far fa-magnifying-glass"
            placeholder="Search"
            className="mx-2 w-72"
            iconPosition="left"
            value={searchText.topic}
            onChange={(e) => {
              handleSearch(e, 'topic')
            }}
            disabled={topicDataLoading}
          />
          <Button.Group basic size="small">
            <Button active={tabName === 'topic'} onClick={() => handleSwitchTab('topic')}>
              Topics
            </Button>
            <Button active={tabName === 'group'} onClick={() => handleSwitchTab('group')}>
              Groups
            </Button>
          </Button.Group>
        </div>
      </div>

      {topicDataLoading ? (
        <Loader withContainer />
      ) : (
        <TopicTable
          dataSource={filteredDataSource.topic}
          handleEditAction={handleEditAction}
          paginationCurrent={pagination.topic.current}
          paginationPageSize={pagination.topic.pageSize}
          handlePageChange={handlePageChange}
          total={filteredDataSource.topic.length}
          paginationName="topic"
          handleToggleActive={handleToggleActive}
          allowAdminOrAbove={allowAdminOrAbove}
          handleDelete={handleDelete}
          updateTopicLoading={updateTopicLoading}
          createTopicLoading={createTopicLoading}
          topicDataLoading={topicDataLoading}
        />
      )}
    </React.Fragment>
  )
}

export default TopicContent



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Topics/TopicContent.js